const {Backbone} = require('backboneAdapter');
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import Template from 'js/templates/file.row.hbs';

require('interfaceAdapter');

export default Backbone.View.extend({
    el: ".listview",
    Template: Template,
    render: function () {
        this.template = Handlebars.compile(this.Template);
        var attributes = this.model.toJSON();
        var templateOutput = this.template(attributes);

        this.$el.append(templateOutput);
        var self = this;
        if (this.myDomId) {
            var id = this.myDomId();
            this.$el.attr("id", id);
        }
    },
    initialize: function () {
        var self = this;
        this.$el.find('.filerowdiv').remove();

        this.render();
        this.$el.show();
        this.$el.find(this.getSelector('.remove-button')).click(() => this.removeView(self));
    },
    superUpdateCallback: GenericView.prototype.updateCallback,
    updateCallback: function (attributeName, value, outcome, e, settings) {
        if ("OK" === outcome) {
            var newHtml = ("true" === value.toString()) ? "true" : "";
            $(e).find('.hidden').html(newHtml);
            if (value) {
                $(e).removeClass('busy');
                $(e).addClass('available');
            } else {
                $(e).addClass('busy');
                $(e).removeClass('available');
            }
        }
        return this.superUpdateCallback(attributeName, value, outcome, e, settings);
    },
    events: {},
    updateTitle: function (name) {
        this.$el.find(this.getSelector('.list-title')).text(name);
    },
    updateProgress: function (progress) {
        const progOuter = this.$el.find(this.getSelector('.progress-bar'));
        progOuter.data("value",progress);
        const prog = this.$el.find(this.getSelector('.progress-bar .bar'));
        prog.width(`${progress}%`);
        this.repaintProgressBar("green");
        if (progress === 100) {
            this.$('.bar').removeClass('progressing');
        } else {
            this.$(".bar").addClass('progressing');
        }
    },
    abort(status) {
        const prog = this.$el.find(this.getSelector('.progress-bar .bar'));
        prog.width('100%');
        this.pauseProgress(status, "red");
    },
    pauseProgress(status, colorCode) {
        if (status) this.updateStatus(status);
        if (colorCode) this.repaintProgressBar(colorCode);
        this.$(".bar").removeClass("progressing");
    },
    repaintProgressBar(color) {
        this.$(".bar").removeClass(function () {
            return [...this.classList]
                .filter(cl => cl.includes("ribbed-"))
                .join(' ');
        }).addClass(`ribbed-${color}`);
    },
    getSelector: function (innerSelector) {
        return `#file-row-${this.model.get('myID')}.list ${innerSelector}`;
    },
    updateStatus: function (status) {
        this.$el.find(this.getSelector('.list-remark')).text(status);
    },
    updateLabel: function (label, value) {
        const labelItem = this.$el.find(this.getSelector(label));
        if (value === null) {
            labelItem.parent().hide();
        } else {
            labelItem.parent().show();
            labelItem.text(value);
        }
    },
    updateContactsReport: function (totalCount, validContacts, duplicateCount, erroneousCount, importedContacts, exceededCount, dateParsingFailsCount, newContactsCount, mergedContactsCount) {

        this.$el.find(this.getSelector('.total-contacts')).text(totalCount);
        this.updateLabel('.valid-contacts', validContacts);
        this.updateLabel('.imported-contacts', importedContacts);
        this.updateLabel('.duplicate-contacts', duplicateCount);
        this.updateLabel('.erroneous-contacts', erroneousCount);
        this.updateLabel('.exceeded-contacts', exceededCount);
        this.updateLabel('.date-parsing-fails', dateParsingFailsCount);
        this.updateLabel('.new-contacts', newContactsCount);
        this.updateLabel('.merged-contacts', mergedContactsCount);
    },
    updateIcon: function (properIcon) {
        var $icon = $('#icon-import');
        $icon.removeClass("icon-file");
        $icon.addClass(properIcon);
    },
    removeView: function (self) {
        self.$(this.getSelector("")).remove();
        if (!this.$el.children().length) {
            this.$el.hide();
        }
    }
});